export default __webpack_public_path__ + "static/media/usdc.181a0b4d.svg";